<template>
  <section>
    <div class="alert alert-info">
      <p>
        Eine Asa ist ein Wiederanschreiben eines Mitglieds, nach dem dieses
        Mitglied bereits in einem Dialog geschrieben hat, aber nicht mehr
        antwortet. Sprich, die Moderation hat die letzte Nachricht geschrieben.
      </p>
      <p>
        Eine Asa Stufe entspricht einer Nachricht. Das heißt, Wenn im System
        eine ASA Stufe eingetragen ist, wird das Mitglied nach der letzten
        Nachricht eines Moderators ein weiteres Mal angeschrieben. Bei 10 ASA
        Stufen wird das Mitglied 10 Mal erneut angeschrieben.
      </p>
    </div>
    <resource
      title="Ändern"
      resource="asa"
      resourceName="ASA"
      :original="original"
      :attributes="[
        {
          name: 'days',
          label: 'Tage'
        },
        {
          name: 'hours',
          label: 'Stunden'
        },
        {
          name: 'minutes',
          label: 'Minuten'
        },
        {
          name: 'tolerance',
          label: 'Toleranz (in Minuten)'
        }
      ]"
    >
      <div slot="title">
        <h4>ASA bearbeiten</h4>
      </div>
    </resource>
  </section>
</template>

<script lang="babel">
import store from "@/store";

export default {
  beforeRouteEnter (to, from, next) {
    store.dispatch('asa/read', [
      {
        name: 'where',
        attributes: {
          id : [Number(to.params.id)],
        }
      },
    ]).then(() => {
      next();
    });
  },
  computed: {
    id() {
      return Number(this.$route.params.id);
    },
    original() {
      return this.$store.getters['asa/find'](this.id);
    },
    updateUrl() {
      return this.original !== undefined ? this.original.update_url : "";
    }
  }
}
</script>
